import { Button, Spinner } from "react-bootstrap";

const SubmitButton = ({ loading }) => {
  return (
    <Button
      disabled={loading}
      type="submit"
      className="me-2 btn-block btn-md"
      variant="primary"
    >
      {loading && (
        <>
          <Spinner as="span" animation="grow" size="sm" /> {"Loading..."}
        </>
      )}
      ບັນທຶກ
    </Button>
  );
};

export default SubmitButton;
